// src/components/Layout.jsx

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';

const Layout = ({ children, title }) => {
    const company = localStorage.getItem("company") || "SUNORA";
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsSidebarOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const themeClass = `theme-${company.toLowerCase()}`;
        document.body.classList.add(themeClass);

        return () => {
            document.body.classList.remove(themeClass);
        };
    }, [company]);

    return (
        <div className={`app-layout ${location.pathname === '/dashboard' ? 'dashboard-active' : ''}`}>
            
            <div className="sidebar-hover-trigger" />
            
            <div className={`sidebar-container ${isSidebarOpen ? 'open' : ''}`}>
                <Sidebar />
            </div>
            {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />}
            
            <main className="content-area">
                {/* --- THIS IS THE KEY CHANGE --- */}
                {/* The scrolling container now wraps BOTH the Header and the children */}
                <div className="page-content">
                    <Header 
                        title={title} 
                        onMenuToggle={() => setIsSidebarOpen(true)} 
                    />
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;